/**
 * DEV-260 FR-011 — rascunho local por DESCRIÇÃO: o que foi digitado e ainda
 * não foi gravado sobrevive a reload. Guarda só o que mudou; campo apagado
 * fica como `null` para não voltar com o valor do servidor. Reload nunca
 * envia nada.
 */
import { omitKeys } from './objects';

type Draft = Record<string, unknown>;

const key = (jobDescriptionId: string) => `alignment-draft:${jobDescriptionId}`;

export function loadDraft(jobDescriptionId: string): Draft {
  try {
    const raw = sessionStorage.getItem(key(jobDescriptionId));
    const parsed: unknown = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? (parsed as Draft) : {};
  } catch {
    return {};
  }
}

function saveDraft(jobDescriptionId: string, draft: Draft): void {
  try {
    sessionStorage.setItem(key(jobDescriptionId), JSON.stringify(draft));
  } catch {
    // sem armazenamento: segue só em memória
  }
}

/** Registra no rascunho as chaves que mudaram de `prev` para `next`. */
export function recordDraftChange(jobDescriptionId: string, prev: Draft, next: Draft): void {
  const draft = loadDraft(jobDescriptionId);
  for (const k of new Set([...Object.keys(prev), ...Object.keys(next)])) {
    if (JSON.stringify(prev[k]) !== JSON.stringify(next[k])) draft[k] = next[k] ?? null;
  }
  saveDraft(jobDescriptionId, draft);
}

/** Respostas do servidor com o rascunho por cima (`null` apaga). */
export function applyDraft(server: Draft, draft: Draft): Draft {
  const cleared = Object.keys(draft).filter((k) => draft[k] === null);
  const filled = Object.fromEntries(Object.entries(draft).filter(([, v]) => v !== null));
  return omitKeys({ ...server, ...filled }, cleared);
}

export function clearDraftKeys(jobDescriptionId: string, keys: string[]): void {
  saveDraft(jobDescriptionId, omitKeys(loadDraft(jobDescriptionId), keys));
}

export function clearDraft(jobDescriptionId: string): void {
  try {
    sessionStorage.removeItem(key(jobDescriptionId));
  } catch {
    // ignora
  }
}
